(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pcstation-brand-carousel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const AUTOPLAY_DELAY = 3000;

    const initialize = (root) => {
      if (!root || root.dataset.brandCarouselReady === 'true') return;
      root.dataset.brandCarouselReady = 'true';

      const track = root.querySelector('[data-brand-track]');
      const previous = root.querySelector('[data-brand-prev]');
      const next = root.querySelector('[data-brand-next]');
      if (!track || !previous || !next) return;

      let inView = !('IntersectionObserver' in window);
      let hovered = false;
      let touching = false;
      let updateFrame = null;
      let disposed = false;

      const updateButtons = () => {
        const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
        previous.disabled = track.scrollLeft <= 4;
        next.disabled = track.scrollLeft >= maxScroll - 4;
      };

      const scheduleUpdate = () => {
        if (!inView || updateFrame !== null) return;
        updateFrame = window.requestAnimationFrame(() => {
          updateFrame = null;
          if (root.isConnected && inView) updateButtons();
        });
      };

      const scroll = (direction) => {
        const distance = Math.max(track.clientWidth * .82, 260);
        track.scrollBy({ left: direction * distance, behavior: reducedMotion.matches ? 'auto' : 'smooth' });
      };

      const autoplayStep = () => {
        const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
        if (maxScroll <= 4) return;

        if (track.scrollLeft >= maxScroll - 4) {
          track.scrollTo({ left: 0, behavior: reducedMotion.matches ? 'auto' : 'smooth' });
        } else {
          scroll(1);
        }
      };

      let autoplayTimer = null;
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      const stopAutoplay = () => {
        if (autoplayTimer !== null) {
          window.clearInterval(autoplayTimer);
          autoplayTimer = null;
        }
      };

      const startAutoplay = () => {
        if (disposed || reducedMotion.matches || document.hidden || !inView || hovered || touching || root.contains(document.activeElement) || autoplayTimer !== null) return;
        autoplayTimer = window.setInterval(autoplayStep, AUTOPLAY_DELAY);
      };

      previous.addEventListener('click', () => scroll(-1));
      next.addEventListener('click', () => scroll(1));
      track.addEventListener('scroll', scheduleUpdate, { passive: true });
      window.addEventListener('resize', scheduleUpdate, { passive: true });

      root.addEventListener('mouseenter', () => { hovered = true; stopAutoplay(); });
      root.addEventListener('mouseleave', () => { hovered = false; startAutoplay(); });
      root.addEventListener('focusin', stopAutoplay);
      root.addEventListener('focusout', () => {
        window.setTimeout(() => {
          if (!root.contains(document.activeElement)) startAutoplay();
        }, 0);
      });
      root.addEventListener('touchstart', () => { touching = true; stopAutoplay(); }, { passive: true });
      const finishTouch = () => { touching = false; startAutoplay(); };
      root.addEventListener('touchend', finishTouch, { passive: true });
      root.addEventListener('touchcancel', finishTouch, { passive: true });

      const handleVisibility = () => {
        if (document.hidden) stopAutoplay();
        else { scheduleUpdate(); startAutoplay(); }
      };
      const handleMotion = () => {
        if (reducedMotion.matches) stopAutoplay();
        else startAutoplay();
      };
      document.addEventListener('visibilitychange', handleVisibility);
      reducedMotion.addEventListener?.('change', handleMotion);

      let observer = null;
      if ('IntersectionObserver' in window) {
        observer = new IntersectionObserver((entries) => {
          inView = entries.some((entry) => entry.isIntersecting);
          if (inView) { scheduleUpdate(); startAutoplay(); }
          else stopAutoplay();
        });
        observer.observe(root);
      }

      root._pcstationStopBrandCarousel = () => {
        disposed = true;
        stopAutoplay();
        observer?.disconnect();
        if (updateFrame !== null) window.cancelAnimationFrame(updateFrame);
        window.removeEventListener('resize', scheduleUpdate);
        document.removeEventListener('visibilitychange', handleVisibility);
        reducedMotion.removeEventListener?.('change', handleMotion);
      };

      scheduleUpdate();
      startAutoplay();
    };

    document.querySelectorAll('[data-brand-carousel]').forEach(initialize);
    document.addEventListener('shopify:section:load', (event) => {
      const root = event.target.querySelector('[data-brand-carousel]');
      initialize(root);
    });
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll('[data-brand-carousel]').forEach((root) => {
        root._pcstationStopBrandCarousel?.();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pcstation-build-your-setup-before-autoplay-3s"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initGamingPaths(root){
    if(!root || root.dataset.gamingPathsReady === 'true') return;
    root.dataset.gamingPathsReady = 'true';

    const track = root.querySelector('[data-gaming-track]');
    const cards = Array.from(root.querySelectorAll('[data-gaming-card]'));
    const dots = Array.from(root.querySelectorAll('[data-gaming-dot]'));
    const prev = root.querySelector('[data-gaming-prev]');
    const next = root.querySelector('[data-gaming-next]');
    const current = root.querySelector('[data-gaming-current]');
    if(!track || !cards.length) return;

    let index = 0;
    let ticking = false;

    function setState(nextIndex){
      index = Math.max(0, Math.min(cards.length - 1, nextIndex));
      dots.forEach(function(dot,i){
        const active = i === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });
      if(current) current.textContent = String(index + 1).padStart(2,'0');
      if(prev) prev.disabled = index === 0;
      if(next) next.disabled = index === cards.length - 1;
    }

    function goTo(nextIndex){
      const target = cards[Math.max(0, Math.min(cards.length - 1, nextIndex))];
      if(!target) return;
      const left = target.offsetLeft - track.offsetLeft;
      track.scrollTo({left:left,behavior:'smooth'});
      setState(nextIndex);
    }

    function syncFromScroll(){
      let nearest = 0;
      let best = Number.POSITIVE_INFINITY;
      const scrollLeft = track.scrollLeft;
      cards.forEach(function(card,i){
        const distance = Math.abs((card.offsetLeft - track.offsetLeft) - scrollLeft);
        if(distance < best){
          best = distance;
          nearest = i;
        }
      });
      setState(nearest);
      ticking = false;
    }

    track.addEventListener('scroll',function(){
      if(ticking) return;
      ticking = true;
      window.requestAnimationFrame(syncFromScroll);
    },{passive:true});

    if(prev) prev.addEventListener('click',function(){goTo(index - 1);});
    if(next) next.addEventListener('click',function(){goTo(index + 1);});
    dots.forEach(function(dot){
      dot.addEventListener('click',function(){
        goTo(Number(dot.dataset.gamingDot));
      });
    });

    setState(0);
  }

  function initAll(scope){
    const target = scope || document;
    target.querySelectorAll('[data-gaming-paths]').forEach(initGamingPaths);
  }

  initAll(document);
  document.addEventListener('shopify:section:load',function(event){initAll(event.target);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pcstation-build-your-setup-before-blue-shade-v1"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initGamingPaths(root){
    if(!root || root.dataset.gamingPathsReady === 'true') return;
    root.dataset.gamingPathsReady = 'true';

    const track = root.querySelector('[data-gaming-track]');
    const cards = Array.from(root.querySelectorAll('[data-gaming-card]'));
    const dots = Array.from(root.querySelectorAll('[data-gaming-dot]'));
    const prev = root.querySelector('[data-gaming-prev]');
    const next = root.querySelector('[data-gaming-next]');
    const current = root.querySelector('[data-gaming-current]');
    if(!track || !cards.length) return;

    let index = 0;
    let ticking = false;

    function setState(nextIndex){
      index = Math.max(0, Math.min(cards.length - 1, nextIndex));
      dots.forEach(function(dot,i){
        const active = i === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });
      if(current) current.textContent = String(index + 1).padStart(2,'0');
      if(prev) prev.disabled = index === 0;
      if(next) next.disabled = index === cards.length - 1;
    }

    function goTo(nextIndex){
      const target = cards[Math.max(0, Math.min(cards.length - 1, nextIndex))];
      if(!target) return;
      const left = target.offsetLeft - track.offsetLeft;
      track.scrollTo({left:left,behavior:'smooth'});
      setState(nextIndex);
    }

    function syncFromScroll(){
      let nearest = 0;
      let best = Number.POSITIVE_INFINITY;
      const scrollLeft = track.scrollLeft;
      cards.forEach(function(card,i){
        const distance = Math.abs((card.offsetLeft - track.offsetLeft) - scrollLeft);
        if(distance < best){
          best = distance;
          nearest = i;
        }
      });
      setState(nearest);
      ticking = false;
    }

    track.addEventListener('scroll',function(){
      if(ticking) return;
      ticking = true;
      window.requestAnimationFrame(syncFromScroll);
    },{passive:true});

    if(prev) prev.addEventListener('click',function(){goTo(index - 1);});
    if(next) next.addEventListener('click',function(){goTo(index + 1);});
    dots.forEach(function(dot){
      dot.addEventListener('click',function(){
        goTo(Number(dot.dataset.gamingDot));
      });
    });

    setState(0);
  }

  function initAll(scope){
    const target = scope || document;
    target.querySelectorAll('[data-gaming-paths]').forEach(initGamingPaths);
  }

  initAll(document);
  document.addEventListener('shopify:section:load',function(event){initAll(event.target);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pcstation-build-your-setup-before-branded-v2"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initGamingPaths(root){
    if(!root || root.dataset.gamingPathsReady === 'true') return;
    root.dataset.gamingPathsReady = 'true';

    const track = root.querySelector('[data-gaming-track]');
    const cards = Array.from(root.querySelectorAll('[data-gaming-card]'));
    const dots = Array.from(root.querySelectorAll('[data-gaming-dot]'));
    const prev = root.querySelector('[data-gaming-prev]');
    const next = root.querySelector('[data-gaming-next]');
    const current = root.querySelector('[data-gaming-current]');
    if(!track || !cards.length) return;

    let index = 0;
    let ticking = false;

    function setState(nextIndex){
      index = Math.max(0, Math.min(cards.length - 1, nextIndex));
      dots.forEach(function(dot,i){
        const active = i === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });
      if(current) current.textContent = String(index + 1).padStart(2,'0');
      if(prev) prev.disabled = index === 0;
      if(next) next.disabled = index === cards.length - 1;
    }

    function goTo(nextIndex){
      const target = cards[Math.max(0, Math.min(cards.length - 1, nextIndex))];
      if(!target) return;
      const left = target.offsetLeft - track.offsetLeft;
      track.scrollTo({left:left,behavior:'smooth'});
      setState(nextIndex);
    }

    function syncFromScroll(){
      let nearest = 0;
      let best = Number.POSITIVE_INFINITY;
      const scrollLeft = track.scrollLeft;
      cards.forEach(function(card,i){
        const distance = Math.abs((card.offsetLeft - track.offsetLeft) - scrollLeft);
        if(distance < best){
          best = distance;
          nearest = i;
        }
      });
      setState(nearest);
      ticking = false;
    }

    track.addEventListener('scroll',function(){
      if(ticking) return;
      ticking = true;
      window.requestAnimationFrame(syncFromScroll);
    },{passive:true});

    if(prev) prev.addEventListener('click',function(){goTo(index - 1);});
    if(next) next.addEventListener('click',function(){goTo(index + 1);});
    dots.forEach(function(dot){
      dot.addEventListener('click',function(){
        goTo(Number(dot.dataset.gamingDot));
      });
    });

    setState(0);
  }

  function initAll(scope){
    const target = scope || document;
    target.querySelectorAll('[data-gaming-paths]').forEach(initGamingPaths);
  }

  initAll(document);
  document.addEventListener('shopify:section:load',function(event){initAll(event.target);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pcstation-build-your-setup-before-clean-images-v3"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initGamingPaths(root){
    if(!root || root.dataset.gamingPathsReady === 'true') return;
    root.dataset.gamingPathsReady = 'true';

    const track = root.querySelector('[data-gaming-track]');
    const cards = Array.from(root.querySelectorAll('[data-gaming-card]'));
    const dots = Array.from(root.querySelectorAll('[data-gaming-dot]'));
    const prev = root.querySelector('[data-gaming-prev]');
    const next = root.querySelector('[data-gaming-next]');
    const current = root.querySelector('[data-gaming-current]');
    if(!track || !cards.length) return;

    let index = 0;
    let ticking = false;

    function setState(nextIndex){
      index = Math.max(0, Math.min(cards.length - 1, nextIndex));
      dots.forEach(function(dot,i){
        const active = i === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });
      if(current) current.textContent = String(index + 1).padStart(2,'0');
      if(prev) prev.disabled = index === 0;
      if(next) next.disabled = index === cards.length - 1;
    }

    function goTo(nextIndex){
      const target = cards[Math.max(0, Math.min(cards.length - 1, nextIndex))];
      if(!target) return;
      const left = target.offsetLeft - track.offsetLeft;
      track.scrollTo({left:left,behavior:'smooth'});
      setState(nextIndex);
    }

    function syncFromScroll(){
      let nearest = 0;
      let best = Number.POSITIVE_INFINITY;
      const scrollLeft = track.scrollLeft;
      cards.forEach(function(card,i){
        const distance = Math.abs((card.offsetLeft - track.offsetLeft) - scrollLeft);
        if(distance < best){
          best = distance;
          nearest = i;
        }
      });
      setState(nearest);
      ticking = false;
    }

    track.addEventListener('scroll',function(){
      if(ticking) return;
      ticking = true;
      window.requestAnimationFrame(syncFromScroll);
    },{passive:true});

    if(prev) prev.addEventListener('click',function(){goTo(index - 1);});
    if(next) next.addEventListener('click',function(){goTo(index + 1);});
    dots.forEach(function(dot){
      dot.addEventListener('click',function(){
        goTo(Number(dot.dataset.gamingDot));
      });
    });

    setState(0);
  }

  function initAll(scope){
    const target = scope || document;
    target.querySelectorAll('[data-gaming-paths]').forEach(initGamingPaths);
  }

  initAll(document);
  document.addEventListener('shopify:section:load',function(event){initAll(event.target);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pcstation-build-your-setup-before-identity-v1"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initGamingPaths(root){
    if(!root || root.dataset.gamingPathsReady === 'true') return;
    root.dataset.gamingPathsReady = 'true';

    const track = root.querySelector('[data-gaming-track]');
    const cards = Array.from(root.querySelectorAll('[data-gaming-card]'));
    const dots = Array.from(root.querySelectorAll('[data-gaming-dot]'));
    const prev = root.querySelector('[data-gaming-prev]');
    const next = root.querySelector('[data-gaming-next]');
    const current = root.querySelector('[data-gaming-current]');
    if(!track || !cards.length) return;

    let index = 0;
    let ticking = false;

    function setState(nextIndex){
      index = Math.max(0, Math.min(cards.length - 1, nextIndex));
      dots.forEach(function(dot,i){
        const active = i === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });
      if(current) current.textContent = String(index + 1).padStart(2,'0');
      if(prev) prev.disabled = index === 0;
      if(next) next.disabled = index === cards.length - 1;
    }

    function goTo(nextIndex){
      const target = cards[Math.max(0, Math.min(cards.length - 1, nextIndex))];
      if(!target) return;
      const left = target.offsetLeft - track.offsetLeft;
      track.scrollTo({left:left,behavior:'smooth'});
      setState(nextIndex);
    }

    function syncFromScroll(){
      let nearest = 0;
      let best = Number.POSITIVE_INFINITY;
      const scrollLeft = track.scrollLeft;
      cards.forEach(function(card,i){
        const distance = Math.abs((card.offsetLeft - track.offsetLeft) - scrollLeft);
        if(distance < best){
          best = distance;
          nearest = i;
        }
      });
      setState(nearest);
      ticking = false;
    }

    track.addEventListener('scroll',function(){
      if(ticking) return;
      ticking = true;
      window.requestAnimationFrame(syncFromScroll);
    },{passive:true});

    if(prev) prev.addEventListener('click',function(){goTo(index - 1);});
    if(next) next.addEventListener('click',function(){goTo(index + 1);});
    dots.forEach(function(dot){
      dot.addEventListener('click',function(){
        goTo(Number(dot.dataset.gamingDot));
      });
    });

    setState(0);
  }

  function initAll(scope){
    const target = scope || document;
    target.querySelectorAll('[data-gaming-paths]').forEach(initGamingPaths);
  }

  initAll(document);
  document.addEventListener('shopify:section:load',function(event){initAll(event.target);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pcstation-build-your-setup-before-title-cleanup"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initGamingPaths(root){
    if(!root || root.dataset.gamingPathsReady === 'true') return;
    root.dataset.gamingPathsReady = 'true';

    const track = root.querySelector('[data-gaming-track]');
    const cards = Array.from(root.querySelectorAll('[data-gaming-card]'));
    const dots = Array.from(root.querySelectorAll('[data-gaming-dot]'));
    const prev = root.querySelector('[data-gaming-prev]');
    const next = root.querySelector('[data-gaming-next]');
    const current = root.querySelector('[data-gaming-current]');
    if(!track || !cards.length) return;

    let index = 0;
    let ticking = false;

    function setState(nextIndex){
      index = Math.max(0, Math.min(cards.length - 1, nextIndex));
      dots.forEach(function(dot,i){
        const active = i === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });
      if(current) current.textContent = String(index + 1).padStart(2,'0');
      if(prev) prev.disabled = index === 0;
      if(next) next.disabled = index === cards.length - 1;
    }

    function goTo(nextIndex){
      const target = cards[Math.max(0, Math.min(cards.length - 1, nextIndex))];
      if(!target) return;
      const left = target.offsetLeft - track.offsetLeft;
      track.scrollTo({left:left,behavior:'smooth'});
      setState(nextIndex);
    }

    function syncFromScroll(){
      let nearest = 0;
      let best = Number.POSITIVE_INFINITY;
      const scrollLeft = track.scrollLeft;
      cards.forEach(function(card,i){
        const distance = Math.abs((card.offsetLeft - track.offsetLeft) - scrollLeft);
        if(distance < best){
          best = distance;
          nearest = i;
        }
      });
      setState(nearest);
      ticking = false;
    }

    track.addEventListener('scroll',function(){
      if(ticking) return;
      ticking = true;
      window.requestAnimationFrame(syncFromScroll);
    },{passive:true});

    if(prev) prev.addEventListener('click',function(){goTo(index - 1);});
    if(next) next.addEventListener('click',function(){goTo(index + 1);});
    dots.forEach(function(dot){
      dot.addEventListener('click',function(){
        goTo(Number(dot.dataset.gamingDot));
      });
    });

    setState(0);
  }

  function initAll(scope){
    const target = scope || document;
    target.querySelectorAll('[data-gaming-paths]').forEach(initGamingPaths);
  }

  initAll(document);
  document.addEventListener('shopify:section:load',function(event){initAll(event.target);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pcstation-build-your-setup-before-two-color-v1"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initGamingPaths(root){
    if(!root || root.dataset.gamingPathsReady === 'true') return;
    root.dataset.gamingPathsReady = 'true';

    const track = root.querySelector('[data-gaming-track]');
    const cards = Array.from(root.querySelectorAll('[data-gaming-card]'));
    const dots = Array.from(root.querySelectorAll('[data-gaming-dot]'));
    const prev = root.querySelector('[data-gaming-prev]');
    const next = root.querySelector('[data-gaming-next]');
    const current = root.querySelector('[data-gaming-current]');
    if(!track || !cards.length) return;

    let index = 0;
    let ticking = false;

    function setState(nextIndex){
      index = Math.max(0, Math.min(cards.length - 1, nextIndex));
      dots.forEach(function(dot,i){
        const active = i === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });
      if(current) current.textContent = String(index + 1).padStart(2,'0');
      if(prev) prev.disabled = index === 0;
      if(next) next.disabled = index === cards.length - 1;
    }

    function goTo(nextIndex){
      const target = cards[Math.max(0, Math.min(cards.length - 1, nextIndex))];
      if(!target) return;
      const left = target.offsetLeft - track.offsetLeft;
      track.scrollTo({left:left,behavior:'smooth'});
      setState(nextIndex);
    }

    function syncFromScroll(){
      let nearest = 0;
      let best = Number.POSITIVE_INFINITY;
      const scrollLeft = track.scrollLeft;
      cards.forEach(function(card,i){
        const distance = Math.abs((card.offsetLeft - track.offsetLeft) - scrollLeft);
        if(distance < best){
          best = distance;
          nearest = i;
        }
      });
      setState(nearest);
      ticking = false;
    }

    track.addEventListener('scroll',function(){
      if(ticking) return;
      ticking = true;
      window.requestAnimationFrame(syncFromScroll);
    },{passive:true});

    if(prev) prev.addEventListener('click',function(){goTo(index - 1);});
    if(next) next.addEventListener('click',function(){goTo(index + 1);});
    dots.forEach(function(dot){
      dot.addEventListener('click',function(){
        goTo(Number(dot.dataset.gamingDot));
      });
    });

    setState(0);
  }

  function initAll(scope){
    const target = scope || document;
    target.querySelectorAll('[data-gaming-paths]').forEach(initGamingPaths);
  }

  initAll(document);
  document.addEventListener('shopify:section:load',function(event){initAll(event.target);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pcstation-build-your-setup"] && !Shopify.designMode) return;
  try {
    
(function(){
  const autoplayMs = 3000;

  function initGamingPaths(root){
    if(!root || root.dataset.gamingPathsReady === 'true') return;
    root.dataset.gamingPathsReady = 'true';

    const track = root.querySelector('[data-gaming-track]');
    const cards = Array.from(root.querySelectorAll('[data-gaming-card]'));
    const dots = Array.from(root.querySelectorAll('[data-gaming-dot]'));
    const prev = root.querySelector('[data-gaming-prev]');
    const next = root.querySelector('[data-gaming-next]');
    const current = root.querySelector('[data-gaming-current]');
    if(!track || !cards.length) return;

    let index = 0;
    let ticking = false;
    let timer = null;
    let inView = !('IntersectionObserver' in window);
    let hovered = false;
    let touching = false;
    let disposed = false;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function setState(nextIndex){
      index = Math.max(0, Math.min(cards.length - 1, nextIndex));
      dots.forEach(function(dot,i){
        const active = i === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });
      if(current) current.textContent = String(index + 1).padStart(2,'0');
      if(prev) prev.disabled = index === 0;
      if(next) next.disabled = index === cards.length - 1;
    }

    function goTo(nextIndex){
      const normalized = (nextIndex + cards.length) % cards.length;
      const target = cards[normalized];
      if(!target) return;
      const left = target.offsetLeft - track.offsetLeft;
      track.scrollTo({left:left,behavior:reducedMotion.matches ? 'auto' : 'smooth'});
      setState(normalized);
    }

    function stop(){
      if(timer){
        window.clearInterval(timer);
        timer = null;
      }
    }

    function start(){
      stop();
      if(!disposed && cards.length > 1 && !document.hidden && inView && !reducedMotion.matches && !hovered && !touching && !root.contains(document.activeElement)){
        timer = window.setInterval(function(){
          goTo(index + 1);
        }, autoplayMs);
      }
    }

    function syncFromScroll(){
      let nearest = 0;
      let best = Number.POSITIVE_INFINITY;
      const scrollLeft = track.scrollLeft;
      cards.forEach(function(card,i){
        const distance = Math.abs((card.offsetLeft - track.offsetLeft) - scrollLeft);
        if(distance < best){
          best = distance;
          nearest = i;
        }
      });
      setState(nearest);
      ticking = false;
    }

    track.addEventListener('scroll',function(){
      if(ticking) return;
      ticking = true;
      window.requestAnimationFrame(syncFromScroll);
    },{passive:true});

    if(prev) prev.addEventListener('click',function(){goTo(index - 1);start();});
    if(next) next.addEventListener('click',function(){goTo(index + 1);start();});
    dots.forEach(function(dot){
      dot.addEventListener('click',function(){
        goTo(Number(dot.dataset.gamingDot));
        start();
      });
    });

    track.addEventListener('touchstart',function(){touching = true;stop();},{passive:true});
    const finishTouch = function(){touching = false;start();};
    track.addEventListener('touchend',finishTouch,{passive:true});
    track.addEventListener('touchcancel',finishTouch,{passive:true});
    root.addEventListener('mouseenter',function(){hovered = true;stop();});
    root.addEventListener('mouseleave',function(){hovered = false;start();});
    root.addEventListener('focusin',stop);
    root.addEventListener('focusout',function(){window.setTimeout(start,0);});

    const handleVisibility = function(){
      if(document.hidden) stop();
      else start();
    };
    document.addEventListener('visibilitychange',handleVisibility);
    const handleMotion = function(){if(reducedMotion.matches) stop();else start();};
    reducedMotion.addEventListener?.('change',handleMotion);

    let observer = null;
    if('IntersectionObserver' in window){
      observer = new IntersectionObserver(function(entries){
        inView = entries.some(function(entry){return entry.isIntersecting;});
        if(inView) start();else stop();
      });
      observer.observe(root);
    }

    root._pcstationStopGamingPaths = function(){
      disposed = true;
      stop();
      observer?.disconnect();
      document.removeEventListener('visibilitychange',handleVisibility);
      reducedMotion.removeEventListener?.('change',handleMotion);
    };

    setState(0);
    start();
  }

  function initAll(scope){
    const target = scope || document;
    target.querySelectorAll('[data-gaming-paths]').forEach(initGamingPaths);
  }

  initAll(document);
  document.addEventListener('shopify:section:load',function(event){initAll(event.target);});
  document.addEventListener('shopify:section:unload',function(event){
    event.target.querySelectorAll('[data-gaming-paths]').forEach(function(root){
      if(root._pcstationStopGamingPaths) root._pcstationStopGamingPaths();
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pcstation-premium-hero-v2-before-autoplay-3s"]) return;
  try {
    
(() => {
  const intervalMs = 5000;

  function initHero(hero) {
    if (!hero || hero.dataset.heroReady === 'true') return;
    hero.dataset.heroReady = 'true';

    const slides = Array.from(hero.querySelectorAll('[data-hero-slide]'));
    const dots = Array.from(hero.querySelectorAll('[data-hero-dot]'));
    const prev = hero.querySelector('[data-hero-prev]');
    const next = hero.querySelector('[data-hero-next]');
    const current = hero.querySelector('[data-hero-current]');

    if (slides.length < 1) return;

    let index = 0;
    let timer = null;
    let touchStartX = null;

    const show = (nextIndex) => {
      index = (nextIndex + slides.length) % slides.length;

      slides.forEach((slide, slideIndex) => {
        const active = slideIndex === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        slide.querySelectorAll('a, button').forEach((node) => {
          node.setAttribute('tabindex', active ? '0' : '-1');
        });
      });

      dots.forEach((dot, dotIndex) => {
        const active = dotIndex === index;
        dot.classList.toggle('is-current', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });

      if (current) current.textContent = String(index + 1);
    };

    const stop = () => {
      if (timer) window.clearTimeout(timer);
      timer = null;
    };

    const schedule = () => {
      stop();
      if (slides.length <= 1 || document.hidden) return;
      timer = window.setTimeout(() => {
        show(index + 1);
        schedule();
      }, intervalMs);
    };

    const go = (nextIndex) => {
      show(nextIndex);
      schedule();
    };

    prev?.addEventListener('click', () => go(index - 1));
    next?.addEventListener('click', () => go(index + 1));

    dots.forEach((dot, dotIndex) => {
      dot.addEventListener('click', () => go(dotIndex));
    });

    hero.addEventListener('touchstart', (event) => {
      touchStartX = event.changedTouches[0]?.clientX ?? null;
      stop();
    }, { passive: true });

    hero.addEventListener('touchend', (event) => {
      if (touchStartX === null) {
        schedule();
        return;
      }

      const endX = event.changedTouches[0]?.clientX ?? touchStartX;
      const delta = endX - touchStartX;
      touchStartX = null;

      if (Math.abs(delta) > 45) {
        show(delta < 0 ? index + 1 : index - 1);
      }

      schedule();
    }, { passive: true });

    const handleVisibility = () => {
      if (document.hidden) stop();
      else schedule();
    };

    document.addEventListener('visibilitychange', handleVisibility);

    hero._pcstationStopHero = () => {
      stop();
      document.removeEventListener('visibilitychange', handleVisibility);
    };

    show(0);
    schedule();
  }

  function initAll(scope) {
    const root = scope || document;
    root.querySelectorAll('[data-pcstation-lifestyle-hero]').forEach(initHero);
  }

  initAll(document);

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-pcstation-lifestyle-hero]').forEach((hero) => {
      hero._pcstationStopHero?.();
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pcstation-premium-hero-v2-before-autoplay-cleanup"]) return;
  try {
    
(() => {
  document.querySelectorAll('[data-pcstation-lifestyle-hero]').forEach((hero) => {
    if (hero.dataset.heroReady === 'true') return;
    hero.dataset.heroReady = 'true';

    const slides = Array.from(hero.querySelectorAll('[data-hero-slide]'));
    const dots = Array.from(hero.querySelectorAll('[data-hero-dot]'));
    const prev = hero.querySelector('[data-hero-prev]');
    const next = hero.querySelector('[data-hero-next]');
    const current = hero.querySelector('[data-hero-current]');
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    let index = 0;
    let timer = null;
    let touchStartX = null;

    const show = (nextIndex) => {
      index = (nextIndex + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        const active = slideIndex === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        slide.querySelectorAll('a, button').forEach((node) => {
          node.setAttribute('tabindex', active ? '0' : '-1');
        });
      });
      dots.forEach((dot, dotIndex) => {
        const active = dotIndex === index;
        dot.classList.toggle('is-current', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });
      if (current) current.textContent = String(index + 1);
    };

    const stop = () => {
      if (timer) window.clearInterval(timer);
      timer = null;
    };

    const start = () => {
      stop();
      if (!reduced.matches && slides.length > 1) {
        timer = window.setInterval(() => show(index + 1), 6500);
      }
    };

    prev?.addEventListener('click', () => {
      show(index - 1);
      start();
    });

    next?.addEventListener('click', () => {
      show(index + 1);
      start();
    });

    dots.forEach((dot, dotIndex) => {
      dot.addEventListener('click', () => {
        show(dotIndex);
        start();
      });
    });

    hero.addEventListener('mouseenter', stop);
    hero.addEventListener('mouseleave', start);
    hero.addEventListener('focusin', stop);
    hero.addEventListener('focusout', (event) => {
      if (!hero.contains(event.relatedTarget)) start();
    });

    hero.addEventListener('touchstart', (event) => {
      touchStartX = event.changedTouches[0]?.clientX ?? null;
      stop();
    }, { passive: true });

    hero.addEventListener('touchend', (event) => {
      if (touchStartX === null) return;
      const endX = event.changedTouches[0]?.clientX ?? touchStartX;
      const delta = endX - touchStartX;
      touchStartX = null;
      if (Math.abs(delta) > 45) show(delta < 0 ? index + 1 : index - 1);
      start();
    }, { passive: true });

    if (reduced.addEventListener) {
      reduced.addEventListener('change', start);
    }

    show(0);
    start();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pcstation-premium-hero-v2-before-flyer-refresh"]) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-pcstation-hero-v2]').forEach((hero) => {
      if (hero.dataset.pcstationHeroReady === 'true') return;
      hero.dataset.pcstationHeroReady = 'true';

      const slides = Array.from(hero.querySelectorAll('[data-hero-slide]'));
      const controls = Array.from(hero.querySelectorAll('[data-hero-control]'));
      if (slides.length < 2) return;

      let current = 0;
      let timer = null;
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      const show = (index) => {
        current = (index + slides.length) % slides.length;
        slides.forEach((slide, i) => {
          const active = i === current;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
        controls.forEach((control, i) => {
          const active = i === current;
          control.classList.toggle('is-current', active);
          control.setAttribute('aria-current', active ? 'true' : 'false');
        });
      };

      const stop = () => {
        if (timer) window.clearInterval(timer);
        timer = null;
      };

      const start = () => {
        if (reducedMotion || timer) return;
        timer = window.setInterval(() => show(current + 1), 7000);
      };

      controls.forEach((control, index) => {
        control.addEventListener('click', () => {
          show(index);
          stop();
          start();
        });
      });

      hero.addEventListener('mouseenter', stop);
      hero.addEventListener('mouseleave', start);
      hero.addEventListener('focusin', stop);
      hero.addEventListener('focusout', start);
      start();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pcstation-premium-hero-v2-before-identity-v1"]) return;
  try {
    
(() => {
  document.querySelectorAll('[data-pcstation-lifestyle-hero]').forEach((hero) => {
    if (hero.dataset.heroReady === 'true') return;
    hero.dataset.heroReady = 'true';

    const slides = Array.from(hero.querySelectorAll('[data-hero-slide]'));
    const dots = Array.from(hero.querySelectorAll('[data-hero-dot]'));
    const prev = hero.querySelector('[data-hero-prev]');
    const next = hero.querySelector('[data-hero-next]');
    const current = hero.querySelector('[data-hero-current]');
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    let index = 0;
    let timer = null;
    let touchStartX = null;

    const show = (nextIndex) => {
      index = (nextIndex + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        const active = slideIndex === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        slide.querySelectorAll('a, button').forEach((node) => {
          node.setAttribute('tabindex', active ? '0' : '-1');
        });
      });
      dots.forEach((dot, dotIndex) => {
        const active = dotIndex === index;
        dot.classList.toggle('is-current', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });
      if (current) current.textContent = String(index + 1);
    };

    const stop = () => {
      if (timer) window.clearInterval(timer);
      timer = null;
    };

    const start = () => {
      stop();
      if (!reduced.matches && slides.length > 1) {
        timer = window.setInterval(() => show(index + 1), 6500);
      }
    };

    prev?.addEventListener('click', () => {
      show(index - 1);
      start();
    });

    next?.addEventListener('click', () => {
      show(index + 1);
      start();
    });

    dots.forEach((dot, dotIndex) => {
      dot.addEventListener('click', () => {
        show(dotIndex);
        start();
      });
    });

    hero.addEventListener('mouseenter', stop);
    hero.addEventListener('mouseleave', start);
    hero.addEventListener('focusin', stop);
    hero.addEventListener('focusout', (event) => {
      if (!hero.contains(event.relatedTarget)) start();
    });

    hero.addEventListener('touchstart', (event) => {
      touchStartX = event.changedTouches[0]?.clientX ?? null;
      stop();
    }, { passive: true });

    hero.addEventListener('touchend', (event) => {
      if (touchStartX === null) return;
      const endX = event.changedTouches[0]?.clientX ?? touchStartX;
      const delta = endX - touchStartX;
      touchStartX = null;
      if (Math.abs(delta) > 45) show(delta < 0 ? index + 1 : index - 1);
      start();
    }, { passive: true });

    if (reduced.addEventListener) {
      reduced.addEventListener('change', start);
    }

    show(0);
    start();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pcstation-premium-hero-v2-before-premium-light"]) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-pcstation-flyer-hero]').forEach((hero) => {
      if (hero.dataset.pcstationFlyerReady === 'true') return;
      hero.dataset.pcstationFlyerReady = 'true';

      const slides = Array.from(hero.querySelectorAll('[data-pcstation-flyer-slide]'));
      const dots = Array.from(hero.querySelectorAll('[data-pcstation-flyer-dot]'));
      const prev = hero.querySelector('[data-pcstation-flyer-prev]');
      const next = hero.querySelector('[data-pcstation-flyer-next]');
      if (slides.length < 2) return;

      let current = 0;
      let timer = null;
      let touchStartX = null;
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      const show = (index) => {
        current = (index + slides.length) % slides.length;
        slides.forEach((slide, i) => {
          const active = i === current;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
          slide.querySelectorAll('a, button').forEach((control) => control.setAttribute('tabindex', active ? '0' : '-1'));
        });
        dots.forEach((dot, i) => {
          const active = i === current;
          dot.classList.toggle('is-current', active);
          dot.setAttribute('aria-current', active ? 'true' : 'false');
        });
      };

      const stop = () => {
        if (timer) window.clearInterval(timer);
        timer = null;
      };
      const start = () => {
        if (reducedMotion || timer) return;
        timer = window.setInterval(() => show(current + 1), 6500);
      };
      const restart = () => { stop(); start(); };

      dots.forEach((dot, index) => dot.addEventListener('click', () => { show(index); restart(); }));
      if (prev) prev.addEventListener('click', () => { show(current - 1); restart(); });
      if (next) next.addEventListener('click', () => { show(current + 1); restart(); });

      hero.addEventListener('touchstart', (event) => {
        touchStartX = event.changedTouches[0]?.clientX ?? null;
      }, { passive: true });
      hero.addEventListener('touchend', (event) => {
        if (touchStartX === null) return;
        const touchEndX = event.changedTouches[0]?.clientX ?? touchStartX;
        const delta = touchEndX - touchStartX;
        touchStartX = null;
        if (Math.abs(delta) < 42) return;
        show(delta < 0 ? current + 1 : current - 1);
        restart();
      }, { passive: true });

      hero.addEventListener('mouseenter', stop);
      hero.addEventListener('mouseleave', start);
      hero.addEventListener('focusin', stop);
      hero.addEventListener('focusout', start);
      document.addEventListener('visibilitychange', () => document.hidden ? stop() : start());

      show(0);
      start();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pcstation-premium-hero-v2"]) return;
  try {
    
(() => {
  // Keep the first hero image stable while Lighthouse and visitors finish the initial render.
  const intervalMs = 7000;

  function initHero(hero) {
    if (!hero || hero.dataset.heroReady === 'true') return;
    hero.dataset.heroReady = 'true';

    const slides = Array.from(hero.querySelectorAll('[data-hero-slide]'));
    const dots = Array.from(hero.querySelectorAll('[data-hero-dot]'));
    const prev = hero.querySelector('[data-hero-prev]');
    const next = hero.querySelector('[data-hero-next]');
    const current = hero.querySelector('[data-hero-current]');

    if (slides.length < 1) return;

    let index = 0;
    let timer = null;
    let touchStartX = null;
    let showRequest = 0;

    const show = async (nextIndex) => {
      const next = (nextIndex + slides.length) % slides.length;
      const request = ++showRequest;
      const slide = slides[next];
      const imageTemplate = slide.querySelector('template[data-hero-image]');
      if (imageTemplate) {
        slide.querySelector('.pcstation-lifestyle-hero__media').appendChild(imageTemplate.content.cloneNode(true));
        imageTemplate.remove();
      }
      const image = slide.querySelector('img');
      if (image && next !== index) {
        image.loading = 'eager';
        if (!image.complete && typeof image.decode === 'function') {
          try { await image.decode(); } catch {}
        }
      }
      if (request !== showRequest) return;
      index = next;

      slides.forEach((slide, slideIndex) => {
        const active = slideIndex === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        slide.querySelectorAll('a, button').forEach((node) => {
          node.setAttribute('tabindex', active ? '0' : '-1');
        });
      });

      dots.forEach((dot, dotIndex) => {
        const active = dotIndex === index;
        dot.classList.toggle('is-current', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });

      if (current) current.textContent = String(index + 1);
    };

    const stop = () => {
      if (timer) window.clearTimeout(timer);
      timer = null;
    };

    const schedule = () => {
      stop();
      if (slides.length <= 1 || document.hidden) return;
      timer = window.setTimeout(async () => {
        await show(index + 1);
        schedule();
      }, intervalMs);
    };

    const go = async (nextIndex) => {
      stop();
      await show(nextIndex);
      schedule();
    };

    prev?.addEventListener('click', () => go(index - 1));
    next?.addEventListener('click', () => go(index + 1));

    dots.forEach((dot, dotIndex) => {
      dot.addEventListener('click', () => go(dotIndex));
    });

    hero.addEventListener('touchstart', (event) => {
      touchStartX = event.changedTouches[0]?.clientX ?? null;
      stop();
    }, { passive: true });

    hero.addEventListener('touchend', (event) => {
      if (touchStartX === null) {
        schedule();
        return;
      }

      const endX = event.changedTouches[0]?.clientX ?? touchStartX;
      const delta = endX - touchStartX;
      touchStartX = null;

      if (Math.abs(delta) > 45) {
        go(delta < 0 ? index + 1 : index - 1);
      } else {
        schedule();
      }
    }, { passive: true });

    const handleVisibility = () => {
      if (document.hidden) stop();
      else schedule();
    };

    document.addEventListener('visibilitychange', handleVisibility);

    hero._pcstationStopHero = () => {
      stop();
      document.removeEventListener('visibilitychange', handleVisibility);
    };

    show(0).then(schedule);
  }

  function initAll(scope) {
    const root = scope || document;
    root.querySelectorAll('[data-pcstation-lifestyle-hero]').forEach(initHero);
  }

  initAll(document);

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-pcstation-lifestyle-hero]').forEach((hero) => {
      hero._pcstationStopHero?.();
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pcstation-premium-hero"]) return;
  try {
    
  const hero = document.querySelector('[data-pcstation-hero]');
  if (hero) {
    const slides = hero.querySelectorAll('[data-hero-slide]');
    const controls = hero.querySelectorAll('[data-hero-control]');
    let current = 0;
    const show = (index) => {
      current = index;
      slides.forEach((slide, i) => { slide.classList.toggle('is-active', i === index); slide.setAttribute('aria-hidden', i === index ? 'false' : 'true'); });
      controls.forEach((control, i) => control.classList.toggle('is-current', i === index));
    };
    controls.forEach((control, index) => control.addEventListener('click', () => show(index)));
    window.setInterval(() => show((current + 1) % slides.length), 7000);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pcstation-razer-spotlight-before-autoplay-3s"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initRazerCarousel(root){
    if(!root || root.dataset.razerReady === 'true') return;
    root.dataset.razerReady='true';

    const slides=Array.from(root.querySelectorAll('[data-razer-slide]'));
    const dots=Array.from(root.querySelectorAll('[data-razer-dot]'));
    const current=root.querySelector('[data-razer-current]');
    const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
    let index=0;
    let timer=null;
    let touchStartX=0;

    function show(nextIndex){
      index=(nextIndex+slides.length)%slides.length;
      slides.forEach(function(slide,i){
        const active=i===index;
        slide.classList.toggle('is-active',active);
        slide.setAttribute('aria-hidden',active?'false':'true');
      });
      dots.forEach(function(dot,i){
        const active=i===index;
        dot.classList.toggle('is-active',active);
        dot.setAttribute('aria-current',active?'true':'false');
      });
      if(current) current.textContent=String(index+1);
    }

    function stop(){
      if(timer){window.clearInterval(timer);timer=null;}
    }

    function start(){
      stop();
      if(!reduced.matches && slides.length>1){
        timer=window.setInterval(function(){show(index+1);},5500);
      }
    }
    dots.forEach(function(dot){
      dot.addEventListener('click',function(){
        show(Number(dot.dataset.razerDot));
        start();
      });
    });

    root.addEventListener('mouseenter',stop);
    root.addEventListener('mouseleave',start);
    root.addEventListener('focusin',stop);
    root.addEventListener('focusout',function(event){
      if(!root.contains(event.relatedTarget)) start();
    });

    root.addEventListener('touchstart',function(event){
      touchStartX=event.changedTouches[0].clientX;
      stop();
    },{passive:true});

    root.addEventListener('touchend',function(event){
      const delta=event.changedTouches[0].clientX-touchStartX;
      if(Math.abs(delta)>45){
        show(delta<0?index+1:index-1);
      }
      start();
    },{passive:true});

    if(reduced.addEventListener){
      reduced.addEventListener('change',function(){start();});
    }

    show(0);
    start();
  }

  function initAll(scope){
    const root=scope || document;
    root.querySelectorAll('[data-razer-carousel]').forEach(initRazerCarousel);
  }

  initAll(document);
  document.addEventListener('shopify:section:load',function(event){initAll(event.target);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pcstation-razer-spotlight-before-desktop-size-fix"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initRazerCarousel(root){
    if(!root || root.dataset.razerReady === 'true') return;
    root.dataset.razerReady='true';

    const slides=Array.from(root.querySelectorAll('[data-razer-slide]'));
    const dots=Array.from(root.querySelectorAll('[data-razer-dot]'));
    const prev=root.querySelector('[data-razer-prev]');
    const next=root.querySelector('[data-razer-next]');
    const current=root.querySelector('[data-razer-current]');
    const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
    let index=0;
    let timer=null;
    let touchStartX=0;

    function show(nextIndex){
      index=(nextIndex+slides.length)%slides.length;
      slides.forEach(function(slide,i){
        const active=i===index;
        slide.classList.toggle('is-active',active);
        slide.setAttribute('aria-hidden',active?'false':'true');
      });
      dots.forEach(function(dot,i){
        const active=i===index;
        dot.classList.toggle('is-active',active);
        dot.setAttribute('aria-current',active?'true':'false');
      });
      if(current) current.textContent=String(index+1);
    }

    function stop(){
      if(timer){window.clearInterval(timer);timer=null;}
    }

    function start(){
      stop();
      if(!reduced.matches && slides.length>1){
        timer=window.setInterval(function(){show(index+1);},5500);
      }
    }

    if(prev) prev.addEventListener('click',function(){show(index-1);start();});
    if(next) next.addEventListener('click',function(){show(index+1);start();});
    dots.forEach(function(dot){
      dot.addEventListener('click',function(){
        show(Number(dot.dataset.razerDot));
        start();
      });
    });

    root.addEventListener('mouseenter',stop);
    root.addEventListener('mouseleave',start);
    root.addEventListener('focusin',stop);
    root.addEventListener('focusout',function(event){
      if(!root.contains(event.relatedTarget)) start();
    });

    root.addEventListener('touchstart',function(event){
      touchStartX=event.changedTouches[0].clientX;
      stop();
    },{passive:true});

    root.addEventListener('touchend',function(event){
      const delta=event.changedTouches[0].clientX-touchStartX;
      if(Math.abs(delta)>45){
        show(delta<0?index+1:index-1);
      }
      start();
    },{passive:true});

    if(reduced.addEventListener){
      reduced.addEventListener('change',function(){start();});
    }

    show(0);
    start();
  }

  function initAll(scope){
    const root=scope || document;
    root.querySelectorAll('[data-razer-carousel]').forEach(initRazerCarousel);
  }

  initAll(document);
  document.addEventListener('shopify:section:load',function(event){initAll(event.target);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pcstation-razer-spotlight"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initRazerCarousel(root){
    if(!root || root.dataset.razerReady === 'true') return;
    root.dataset.razerReady='true';

    const slides=Array.from(root.querySelectorAll('[data-razer-slide]'));
    const dots=Array.from(root.querySelectorAll('[data-razer-dot]'));
    const current=root.querySelector('[data-razer-current]');
    let index=0;
    let timer=null;
    let touchStartX=0;
    let carouselVisible=!('IntersectionObserver' in window);
    const reduceMotion=window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function show(nextIndex){
      index=(nextIndex+slides.length)%slides.length;
      slides.forEach(function(slide,i){
        const active=i===index;
        slide.classList.toggle('is-active',active);
        if(active) slide.removeAttribute('inert');
        else slide.setAttribute('inert','');
        slide.setAttribute('aria-hidden',active?'false':'true');
      });
      dots.forEach(function(dot,i){
        const active=i===index;
        dot.classList.toggle('is-active',active);
        dot.setAttribute('aria-current',active?'true':'false');
      });
      if(current) current.textContent=String(index+1);
    }

    function stop(){
      if(timer){window.clearInterval(timer);timer=null;}
    }

    function start(){
      stop();
      if(slides.length>1 && carouselVisible && !document.hidden && !reduceMotion){
        timer=window.setInterval(function(){show(index+1);},3000);
      }
    }
    dots.forEach(function(dot){
      dot.addEventListener('click',function(){
        show(Number(dot.dataset.razerDot));
        start();
      });
    });

    root.addEventListener('touchstart',function(event){
      touchStartX=event.changedTouches[0].clientX;
      stop();
    },{passive:true});

    root.addEventListener('touchend',function(event){
      const delta=event.changedTouches[0].clientX-touchStartX;
      if(Math.abs(delta)>45){
        show(delta<0?index+1:index-1);
      }
      start();
    },{passive:true});

    show(0);
    if('IntersectionObserver' in window){
      const observer=new IntersectionObserver(function(entries){
        carouselVisible=entries.some(function(entry){return entry.isIntersecting;});
        if(carouselVisible) start();
        else stop();
      },{rootMargin:'160px 0px',threshold:0});
      observer.observe(root);
    }else{
      start();
    }
    document.addEventListener('visibilitychange',function(){
      if(document.hidden) stop();
      else start();
    });
  }

  function initAll(scope){
    const root=scope || document;
    root.querySelectorAll('[data-razer-carousel]').forEach(initRazerCarousel);
  }

  initAll(document);
  document.addEventListener('shopify:section:load',function(event){initAll(event.target);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pcstation-storefront-hub-before-12"]) return;
  try {
    
  document.querySelectorAll('[data-pcstation-featured-carousel]').forEach((carousel) => {
    const track = carousel.querySelector('[data-featured-track]');
    const slides = Array.from(carousel.querySelectorAll('[data-featured-slide]'));
    const prev = carousel.querySelector('[data-featured-prev]');
    const next = carousel.querySelector('[data-featured-next]');
    const currentLabel = carousel.querySelector('[data-featured-current]');

    if (!track || slides.length < 2 || !prev || !next) return;

    let current = 0;
    let touchStartX = null;

    const show = (index) => {
      current = (index + slides.length) % slides.length;
      track.style.transform = `translate3d(-${current * 100}%, 0, 0)`;
      slides.forEach((slide, slideIndex) => {
        const active = slideIndex === current;
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        slide.setAttribute('tabindex', active ? '0' : '-1');
      });
      if (currentLabel) currentLabel.textContent = String(current + 1);
    };

    prev.addEventListener('click', () => show(current - 1));
    next.addEventListener('click', () => show(current + 1));

    carousel.addEventListener('touchstart', (event) => {
      touchStartX = event.changedTouches[0]?.clientX ?? null;
    }, { passive: true });

    carousel.addEventListener('touchend', (event) => {
      if (touchStartX === null) return;
      const touchEndX = event.changedTouches[0]?.clientX ?? touchStartX;
      const delta = touchEndX - touchStartX;
      touchStartX = null;
      if (Math.abs(delta) < 35) return;
      show(delta < 0 ? current + 1 : current - 1);
    }, { passive: true });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pcstation-storefront-hub"]) return;
  try {
    
(() => {
  document.querySelectorAll('[data-pcstation-hot-deals]').forEach((root) => {
    if (root.dataset.carouselReady === 'true') return;
    root.dataset.carouselReady = 'true';
    const track = root.querySelector('[data-deals-track]');
    const controls = root.querySelector('[data-deals-controls]');
    const prev = root.querySelector('[data-deals-prev]');
    const next = root.querySelector('[data-deals-next]');
    if (!track || !prev || !next || !controls) return;

    const amount = () => {
      const card = track.querySelector('.pcstation-hot-deals__item');
      if (!card) return track.clientWidth * 0.8;
      const styles = window.getComputedStyle(track);
      const gap = parseFloat(styles.columnGap || styles.gap || 0) || 0;
      return (card.getBoundingClientRect().width + gap) * 2;
    };

    const update = () => {
      const max = Math.max(0, track.scrollWidth - track.clientWidth);
      controls.hidden = max < 4;
      prev.disabled = track.scrollLeft <= 3;
      next.disabled = track.scrollLeft >= max - 3;
    };

    prev.addEventListener('click', () => track.scrollBy({ left: -amount(), behavior: 'smooth' }));
    next.addEventListener('click', () => track.scrollBy({ left: amount(), behavior: 'smooth' }));
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pcstation-tabbed-collection"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(event) {
  const button = event.target.closest('[data-tabbed-collection] [data-tab-button]');
  if (!button) return;
  const root = button.closest('[data-tabbed-collection]');
  const target = button.dataset.target;
  root.querySelectorAll('[data-tab-button]').forEach(function(tab) {
    const active = tab === button;
    tab.classList.toggle('is-active', active);
    tab.setAttribute('aria-selected', active ? 'true' : 'false');
  });
  root.querySelectorAll('[data-tab-panel]').forEach(function(panel) {
    const active = panel.dataset.tabPanel === target;
    if (active) {
      const content = panel.querySelector('script[data-tab-content]');
      if (content) {
        const template = document.createElement('template');
        template.innerHTML = JSON.parse(content.textContent);
        panel.appendChild(template.content);
        content.remove();
        document.dispatchEvent(new CustomEvent('pcstation:products-rendered', { detail: { root: panel } }));
      }
    }
    panel.hidden = !active;
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pcstation-ugreen-spotlight"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initUGreen(root){
    if(!root || root.dataset.ugreenReady==='true') return;
    root.dataset.ugreenReady='true';

    const slides=Array.from(root.querySelectorAll('[data-ugreen-slide]'));
    const dots=Array.from(root.querySelectorAll('[data-ugreen-dot]'));
    const current=root.querySelector('[data-ugreen-current]');
    let index=0;
    let timer=null;
    let touchStartX=0;
    let carouselVisible=!('IntersectionObserver' in window);
    const reduceMotion=window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function show(nextIndex){
      index=(nextIndex+slides.length)%slides.length;
      slides.forEach(function(slide,i){
        const active=i===index;
        slide.classList.toggle('is-active',active);
        if(active) slide.removeAttribute('inert');
        else slide.setAttribute('inert','');
        slide.setAttribute('aria-hidden',active?'false':'true');
        const cta=slide.querySelector('[data-ugreen-cta]');
        if(cta) cta.setAttribute('tabindex',active?'0':'-1');
      });
      dots.forEach(function(dot,i){
        const active=i===index;
        dot.classList.toggle('is-active',active);
        dot.setAttribute('aria-current',active?'true':'false');
      });
      if(current) current.textContent=String(index+1);
    }

    function stop(){
      if(timer){
        window.clearInterval(timer);
        timer=null;
      }
    }

    function start(){
      stop();
      if(slides.length>1 && carouselVisible && !document.hidden && !reduceMotion){
        timer=window.setInterval(function(){show(index+1);},3000);
      }
    }

    dots.forEach(function(dot){
      dot.addEventListener('click',function(){
        show(Number(dot.dataset.ugreenDot));
        start();
      });
    });

    root.addEventListener('touchstart',function(event){
      touchStartX=event.changedTouches[0].clientX;
      stop();
    },{passive:true});

    root.addEventListener('touchend',function(event){
      const delta=event.changedTouches[0].clientX-touchStartX;
      if(Math.abs(delta)>45){
        show(delta<0?index+1:index-1);
      }
      start();
    },{passive:true});

    show(0);
    if('IntersectionObserver' in window){
      const observer=new IntersectionObserver(function(entries){
        carouselVisible=entries.some(function(entry){return entry.isIntersecting;});
        if(carouselVisible) start();
        else stop();
      },{rootMargin:'160px 0px',threshold:0});
      observer.observe(root);
    }else{
      start();
    }
    document.addEventListener('visibilitychange',function(){
      if(document.hidden) stop();
      else start();
    });
  }

  function initAll(scope){
    const base=scope||document;
    base.querySelectorAll('[data-ugreen-slider]').forEach(initUGreen);
  }

  initAll(document);
  document.addEventListener('shopify:section:load',function(event){initAll(event.target);});
})();

  } catch(e) { console.error(e); }
})();
})();
